"use strict";
/**
 * Treatment Modality — per-slug modality classification.
 *
 * Maps each TreatmentSlug to its modality (Injectable, Device, Professional, etc.).
 * This is more granular than TreatmentCategory because a single category can
 * contain multiple modalities (e.g. facial_treatments includes both Device-based
 * LED therapy and Professional facials).
 *
 * Used by the backend to write modality into section content, and by the frontend
 * via i18n to render the modality badge on treatment rows.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TREATMENT_SLUG_MODALITY = exports.treatmentModalityEnum = exports.TreatmentModality = void 0;
exports.getTreatmentModality = getTreatmentModality;
const skin_1 = require("./skin");
// ---------------------------------------------------------------------------
// Modality Enum
// ---------------------------------------------------------------------------
exports.TreatmentModality = {
    injectable: 'injectable',
    device: 'device',
    professional: 'professional',
    specialist: 'specialist',
    body: 'body',
    wellness: 'wellness',
};
exports.treatmentModalityEnum = [
    exports.TreatmentModality.injectable,
    exports.TreatmentModality.device,
    exports.TreatmentModality.professional,
    exports.TreatmentModality.specialist,
    exports.TreatmentModality.body,
    exports.TreatmentModality.wellness,
];
exports.TREATMENT_SLUG_MODALITY = {
    // Injectables
    [skin_1.TreatmentSlug.anti_wrinkle]: exports.TreatmentModality.injectable,
    [skin_1.TreatmentSlug.dermal_fillers]: exports.TreatmentModality.injectable,
    [skin_1.TreatmentSlug.skin_boosters]: exports.TreatmentModality.injectable,
    [skin_1.TreatmentSlug.bioremodelling]: exports.TreatmentModality.injectable,
    [skin_1.TreatmentSlug.pdo_threads]: exports.TreatmentModality.injectable,
    [skin_1.TreatmentSlug.collagen_stimulators]: exports.TreatmentModality.injectable,
    [skin_1.TreatmentSlug.fat_dissolving_injections]: exports.TreatmentModality.injectable,
    // Devices
    [skin_1.TreatmentSlug.led_light_therapy]: exports.TreatmentModality.device,
    [skin_1.TreatmentSlug.ipl]: exports.TreatmentModality.device,
    [skin_1.TreatmentSlug.rf_microneedling]: exports.TreatmentModality.device,
    [skin_1.TreatmentSlug.hifu]: exports.TreatmentModality.device,
    [skin_1.TreatmentSlug.muscle_defining]: exports.TreatmentModality.device,
    [skin_1.TreatmentSlug.laser_skin_resurfacing]: exports.TreatmentModality.device,
    // Professional treatments
    [skin_1.TreatmentSlug.facials]: exports.TreatmentModality.professional,
    [skin_1.TreatmentSlug.acne_treatments]: exports.TreatmentModality.professional,
    [skin_1.TreatmentSlug.hydrafacial]: exports.TreatmentModality.professional,
    [skin_1.TreatmentSlug.chemical_peels]: exports.TreatmentModality.professional,
    [skin_1.TreatmentSlug.microdermabrasion]: exports.TreatmentModality.professional,
    [skin_1.TreatmentSlug.microneedling]: exports.TreatmentModality.professional,
    [skin_1.TreatmentSlug.plasma_pen]: exports.TreatmentModality.professional,
    [skin_1.TreatmentSlug.oxygen_facials]: exports.TreatmentModality.professional,
    // Specialist
    [skin_1.TreatmentSlug.exosomes]: exports.TreatmentModality.specialist,
    [skin_1.TreatmentSlug.rejuran]: exports.TreatmentModality.specialist,
    [skin_1.TreatmentSlug.nctf_skin_booster]: exports.TreatmentModality.specialist,
    [skin_1.TreatmentSlug.prp_skin]: exports.TreatmentModality.specialist,
    // Body
    [skin_1.TreatmentSlug.fat_freezing]: exports.TreatmentModality.body,
    [skin_1.TreatmentSlug.ultrasonic_fat_cavitation]: exports.TreatmentModality.body,
    // Wellness
    [skin_1.TreatmentSlug.iv_vitamin_infusions]: exports.TreatmentModality.wellness,
};
/**
 * Get the modality key for a treatment slug.
 * Falls back to 'professional' for unknown slugs.
 */
function getTreatmentModality(slug) {
    return (exports.TREATMENT_SLUG_MODALITY[slug] ??
        exports.TreatmentModality.professional);
}
//# sourceMappingURL=treatmentModality.js.map